import script from "./ReadingListCallout16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadingListCallout16167.vue?vue&type=script&setup=true&lang=ts"

import "./ReadingListCallout16167.vue?vue&type=style&index=0&id=ad184960&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad184960"]])

export default __exports__